import _ from 'underscore';
import Promise from 'bluebird';
import { lambdaConvertForArrayTypes } from './update-odata-options-for-array-type';

let i18n = null;
let schemaI18nCampaign = null;
let languageI18n = null;
let s$AdGroup = null;
let globalConfig = null;

function getLanguagesItems() {
  let languages = _.without(s$AdGroup.properties.Language.enum, 'All', 'None');
  const Permissions = globalConfig.get('Permissions');

  languages.unshift('All'); // Make all language into header of array

  if (!Permissions.IsSimplifiedChineseLanguageEnabledInMultipleLanguage) {
    languages = _.without(languages, 'SimplifiedChinese');
  }

  if (!Permissions.IsAdsGlobalizationPhase1Enabled) {
    languages = _.without(languages, 'Greek', 'Polish', 'Bulgarian', 'Croatian', 'Czech', 'Estonian', 'Hungarian', 'Latvian', 'Lithuanian', 'Maltese', 'Romanian', 'Slovak', 'Slovenian');
  }

  if (!Permissions.IsAdsGlobalizationPhase2Enabled) {
    languages = _.without(languages, 'Turkish', 'Serbian', 'Bosnian', 'Albanian', 'Macedonian', 'Icelandic');
  }

  if (!Permissions.IsAdsGlobalizationPhase6Enabled) {
    languages = _.without(languages, 'Hebrew', 'Arabic', 'Russian');
  }

  if (!Permissions.IsAdsGlobalizationPhase2JapanEnabled) {
    languages = _.without(languages, 'Japanese');
  }

  if (!Permissions.IsAdsGlobalizationPhase9Enabled) {
    languages = _.without(languages, 'Hindi', 'Malay', 'Thai', 'Indonesian', 'Tagalog');
  }

  if (!Permissions.IsAdsGlobalizationPhase9VIEnabled) {
    languages = _.without(languages, 'Vietnamese');
  }

  if (Permissions.IsDomesticSimplifiedChineseEnabled) {
    languages = ['SimplifiedChinese'];
  }

  return _.map(languages, language => ({ Id: language, Name: languageI18n.getString(`Language_${language}`) }));
}

class LanaguageDataSource {
  constructor() {
    this.languages = getLanguagesItems();
  }

  get(_viewFilter, searchFilter) {
    if (!searchFilter) {
      return Promise.resolve(this.languages);
    }

    const searchFilterLowerCase = searchFilter.toLowerCase();
    const languagesToReturn =
      _.select(
        this.languages,
        language => language.Name.toLowerCase().indexOf(searchFilterLowerCase) === 0
      );

    return Promise.resolve(languagesToReturn);
  }

  getByIds() {
    return Promise.resolve(this.languages);
  }
}

export function initialize(options) {
  ({
    i18n,
    schemaI18nCampaign,
    languageI18n,
    s$AdGroup,
    globalConfig,
  } = options);
}

export function updateEntitySchemaForCampaignLanguages(entitySchema) {
  const entitySchemaCopy = entitySchema;

  entitySchemaCopy.properties.Languages = {
    property: 'Languages',
    name: schemaI18nCampaign.property('Campaign', 'Languages'),
    title: schemaI18nCampaign.property('Campaign', 'Languages'),
    operatorDisplayNameMap: {
      containsall: i18n.getString('FilterOperator_ContainsAll'),
      containsany: i18n.getString('FilterOperator_ContainsAny'),
      containsnone: i18n.getString('FilterOperator_ContainsNone'),
    },
    operators: ['containsall', 'containsany', 'containsnone'],
    type: 'id',
    filterable: true,
    addtionalParams: {
      dataSource: new LanaguageDataSource(),
      selectorOptions: {
        keyMap: {
          // eslint-disable-next-line camelcase
          Selector_Filter_Placeholder: () => i18n.getString('LanguageLabelText'),
        },
      },
    },
  };
  return entitySchemaCopy;
}

export function updateOdataOptionsForCampaignLanguages(options) {
  const optionsCopy = options || { custom: {} };

  _.extendOwn(optionsCopy.custom, {
    Languages: {
      containsall: lambdaConvertForArrayTypes('and', 'any', 'eq', 'Languages', 'Language'),
      containsany: lambdaConvertForArrayTypes('or', 'any', 'eq', 'Languages', 'Language'),
      containsnone: lambdaConvertForArrayTypes('and', 'all', 'ne', 'Languages', 'Language'),
    },
  });
  return optionsCopy;
}
